/*
 * @Description: 产品item（首页和产品列表页）
 * @Author: oubu
 * @Date: 2020-02-27
 */
import React, { Component } from 'react';
import { Flex, Toast, Modal } from 'antd-mobile';
import { toastActivityNotStarted } from 'utils/activityTips';
import './index.less';
import Util from 'utils';
import cx from 'classnames';
import { inject, observer } from 'mobx-react';
import MyCollectMod from 'pages/Shop/Member/Personal/MyCollect/MyCollectMod';
import _, { indexOf } from 'lodash';
import { PriceText } from 'widget';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import { toJS } from 'mobx';
import SkuModal from 'pages/Shop/Product/ProductDetail/SkuModal/SkuModalView';
import CornerMarker from 'pubBiz/CornerMarker';
import CollectionBtn from 'pubBiz/CollectionBtn';
import { getFromSourceParam } from 'biz-micro-services-ui/project/pria/utils/util';
import { ImgWrap } from 'pubBiz';
import { checkShowTipModal } from 'biz-micro-services-ui/project/middlePlatform/function/common';

const Alert = Modal.alert;

@inject('AppMod')
@inject('ShoppingCartMod')
@inject('BusinessCardMod')
@inject('QualificationMod')
@observer
export default class ProductItemView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showMuitySpecificationModal: false,
      selectSpecificationIndex: -1,
      selectObject: {}
    };
    this.qualifyStores = this.props.QualificationMod;
    this.businessStores = this.props.BusinessCardMod;
    this.fromActiveSource = this.props.fromActiveSource;
    this.myCollectMod = new MyCollectMod();
    this.collect = _.throttle(() => {
      this._collect();
    }, 500);
    this.collectShow = _.throttle(() => {
      this._collectShow();
    }, 500);
  }

  componentDidMount() {
    // this.businessStores.getProductRecommendIdList({mallType:2});
  }

  /**
   * 产品是否收藏
   */
  get isCollected() {
    if (this.props.isFromMyCollect) {
      // 从我的收藏进来
      return true;
    }
    let isCollected = false;

    this.props.AppMod.collectIds.some((id) => {
      if (id == this.props.data.id) {
        isCollected = true;
        return true;
      }
    });
    return isCollected;
  }

  /**
   * 大数据埋点
   * 1、商品详情页的关联推荐商品
   * 2、支付成功页 - 买了又买
   */
  bigDataTrack = () => {
    const { trackType = '', data } = this.props;

    // 如果没有埋点类型，则不需埋点
    if (!trackType) {
      return;
    }

    const { id, isBigDataRecommend, subActivity: shareActivityId } = data || {};

    let eventName = '';
    if (trackType == 'detail') {
      // 商品详情页的关联推荐商品
      eventName = 'commodityDetailClick';
    } else if (trackType == 'rebuy') {
      // 支付成功页的推荐商品
      eventName = 'commodityRebuyClick';
    }

    if (!eventName) {
      return;
    }

    window.sensors.track(eventName, {
      commodity_id: id,
      is_recommend: isBigDataRecommend ? 1 : 0 // 是否智能推荐
    });
  };

  goDetail = async () => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    // 跳转去详情页之前，先埋点
    this.bigDataTrack();
    if (this.props.onClick) {
      this.props.onClick();
      return;
    }
    // isQualification - 是否是资格购产品
    const { data, activityType, activityId, source, ment = '' } = this.props;
    console.log(this.props, 'this.propsthis.propsthis.props');
    const { id, type } = data;
    let fromActiveSourceSearch = '';
    if (this.fromActiveSource) {
      const fromActiveSourceParam = getFromSourceParam(this.fromActiveSource);
      Object.keys(fromActiveSourceParam).map((d) => {
        fromActiveSourceSearch = fromActiveSourceSearch + `&${d}=${fromActiveSourceParam[d]}`;
      });
    }
    // 如果是参加活动的商品，需要传递给详情
    if (activityType) {
      let search = !activityId
        ? `activityType=${activityType}&source=${source}${
            this.props.isSelectMall ? '&isSelectMall=true' : ''
          }${fromActiveSourceSearch}&ment=${ment}`
        : `activityType=${activityType}&activityId=${activityId}&source=${source}${
            this.props.isSelectMall ? '&isSelectMall=true' : ''
          }${fromActiveSourceSearch}&ment=${ment}`;
      window.app.routerGoTo({
        pathname: `/shop/productDetail/${id}`,
        search,
        state: {
          sourceTag: this.props.sourceTag || ''
        }
      });
      return;
    }
    let search = type
      ? `type=${type}&source=${source}${
          this.props.isSelectMall ? '&isSelectMall=true' : ''
        }${fromActiveSourceSearch}&ment=${ment}`
      : `source=${source}${
          this.props.isSelectMall ? '&isSelectMall=true' : ''
        }${fromActiveSourceSearch}&ment=${ment}`;
    window.app.routerGoTo({
      pathname: `/shop/productDetail/${id}`,
      search,
      state: {
        sourceTag: this.props.sourceTag || ''
      }
    });
  };

  /**
   * 收藏
   */
  doCollect = async (showCart) => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    // e.stopPropagation();
    // showCart==1的时候是资格购传入
    console.log('showCart', showCart);

    if (!this.props.AppMod.token) {
      window.app.routerGoTo('/login');
      return;
    }
    if (showCart == 1) {
      this.props.isFromMyCollect
        ? Alert('', '是否取消收藏？', [
            { text: '取消' },
            {
              text: '确定',
              onPress: () => {
                this.collectShow();
              }
            }
          ])
        : this.collectShow();
    } else {
      this.props.isFromMyCollect
        ? Alert('', '是否取消收藏？', [
            { text: '取消' },
            {
              text: '确定',
              onPress: () => {
                this.collect();
              }
            }
          ])
        : this.collect();
    }

    // this.props.isFromMyCollect
    //   ? Alert('', '是否取消收藏？', [
    //     { text: '取消' },
    //     {
    //       text: '确定',
    //       onPress: () => {
    //         this.collect();
    //       },
    //     },
    //   ])
    //   : this.collect();
  };

  /**
   * 加入收藏夹
   */
  _collect = async () => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    const { activityType, activityId } = this.props;
    const { id, name, price = '', activeId = '' } = this.props.data || {};
    let params = {
      id,
      name,
      price
    };
    if (!this.isCollected) {
      params = {
        id,
        itemId: id,
        activeId: activityId,
        activeType: activityType,
        name,
        price
      };
    }
    this.myCollectMod.collect(this.isCollected, [params], activeId).then((result) => {
      if (result) {
        if (!this.props.isFromMyCollect) {
          Toast.info(result.isCollected ? '收藏成功' : '取消收藏', 2);

          let collectIds = [...this.props.AppMod.collectIds];
          if (result.isCollected) {
            collectIds.push(id);
          } else {
            const index = collectIds.indexOf(id);
            if (index >= 0) {
              collectIds.splice(index, 1);
            }
          }
          this.props.AppMod.changeState('collectIds', collectIds);
        } else {
          this.props.refresh && this.props.refresh();
        }
      }
    });
  };

  _collectShow = async () => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    let res = await this.qualifyStores.getActivity();
    if (res == 0) {
      Toast.info('当前活动已结束，请勿下单！');
    } else if (res == 2) {
      const { activityId } = this.props;
      const activeId = activityId || (this.props.data && this.props.data.activityId);
      toastActivityNotStarted(activeId);
    } else {
      const { id, name, price = '', activityId: activeId = '' } = this.props.data || {};
      let params = {
        id,
        name,
        price
      };
      const { activityType, activityId } = this.props;
      if (!this.isCollected) {
        params = {
          id,
          itemId: id,
          activeId: activityId,
          activeType: activityType,
          name,
          price
        };
      }
      this.myCollectMod.collect(this.isCollected, [params], activeId).then((result) => {
        if (result) {
          if (!this.props.isFromMyCollect) {
            Toast.info(result.isCollected ? '收藏成功' : '取消收藏', 2);

            let collectIds = [...this.props.AppMod.collectIds];
            if (result.isCollected) {
              collectIds.push(id);
            } else {
              const index = collectIds.indexOf(id);
              if (index >= 0) {
                collectIds.splice(index, 1);
              }
            }
            this.props.AppMod.changeState('collectIds', collectIds);
          } else {
            this.props.refresh && this.props.refresh();
          }
        }
      });
    }
  };

  /**
   * 加入购物车
   */
  addCart = async (type, showCart) => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    if (!this.props.AppMod.token) {
      window.app.routerGoTo('/login');
      return;
    }
    const { code, name, itemSerial, id, itemId } = this.props.data;
    const s = await checkShowTipModal({
      code,
      name,
      activity: '99微购',
      itemId: itemSerial || id || itemId
    });
    if (s) return;

    if (+type === 5) {
      this.setState({ showMuitySpecificationModal: true });
      return;
    }
    // 多规格商品 type==6
    if (type == 6) {
      this.props.ShoppingCartMod.changeState({ productInfo: this.props.data });
      let subItemList = this.props.data.subItemList || [];
      if (subItemList.length > 0) {
        this.props.ShoppingCartMod.changeState({
          moreSpecificationsData: subItemList,
          showSkuModal: true
        });
        return;
      }
      this.props.ShoppingCartMod.getMoreMultiList(this.props.data.id).then((result) => {
        console.log(this.props.data);
        if (result) {
          this.props.ShoppingCartMod.changeState({ showSkuModal: true });
        }
      });
      return;
    }
    if (showCart == 1) {
      this.addTheCartShow(this.props.data || {});
    } else {
      this.addTheCart(this.props.data || {});
    }
  };

  addTheCart = async (data) => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    const { name, id, skuId, price } = data;
    const params = {
      itemName: name,
      itemNum: 1,
      itemSerial: id,
      skuSerial: skuId,
      price: price || '',
      fromActiveSource: this.fromActiveSource
    };
    if (this.props.sourceTag) {
      params.referrer = `${this.props.sourceTag}-加入购物车`;
    }

    const { allowDistributionRatio } = this.props;
    // if (allowDistributionRatio) {
    //   Toast.info('该产品不可加入购物车，请选择立即购买或快速购物', 2);
    //   return
    // }
    if (this.props.isSelectMall) {
      this.props.ShoppingCartMod.addSelectMallCart(params, 0).then((result) => {
        if (result) {
          Util.toastCanClick('加入购物车成功');
        }
      });
    } else {
      this.props.ShoppingCartMod.addCart(params).then((result) => {
        if (result) {
          Util.toastCanClick('加入购物车成功');
        }
      });
    }
  };

  addTheCartShow = async (data) => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    const { name, id, skuId, price } = data;
    const params = {
      itemName: name,
      itemNum: 1,
      itemSerial: id,
      skuSerial: skuId,
      price: price || ''
    };
    if (this.props.sourceTag) {
      params.referrer = `${this.props.sourceTag}-加入购物车`;
    }
    const { allowDistributionRatio } = this.props;
    // if (allowDistributionRatio) {
    //   Toast.info('该产品不可加入购物车，请选择立即购买或快速购物', 2);
    //   return
    // }

    let res = await this.qualifyStores.getActivity();
    console.log('res==>', res);
    if (res == 0) {
      Toast.info('当前活动已结束，请勿下单！');
    } else if (res == 2) {
      const { activityId } = this.props;
      const activeId = activityId || (this.props.data && this.props.data.activityId);
      toastActivityNotStarted(activeId);
    } else {
      this.props.ShoppingCartMod.addCart(params).then((result) => {
        if (result) {
          Toast.info('加入购物车成功', 2);
        }
      });
    }
  };

  /**
   * 推荐商品逻辑
   */
  recommedProduct = (e, status) => {
    e.stopPropagation(); // 阻止冒泡事件
    if (status == 1) {
      // 加入推荐
      this.businessStores.addProductRecommend({ itemId: this.props.data.id }).then((result) => {
        result == 0 && this.businessStores.getProductRecommendIdList({ mallType: 2 });
      });
    } else {
      // 取消推荐
      const itemIds = this.props.data.id;
      this.businessStores.productDelete({ itemIds }).then((result) => {
        if (result == 0) {
          this.businessStores.getProductRecommendIdList({ mallType: 2 });
          // Toast.info('删除成功',1);
        }
      });
    }
  };

  /**
   * 推荐样式
   */
  renderRecommend = (sign, idValue) => {
    const { productRecommendIdList } = this.businessStores;
    const status = productRecommendIdList.indexOf(idValue) != -1 ? -1 : 1;
    console.log(status);
    if (sign == 'ItemSquare') {
      return (
        <Flex
          justify="center"
          className={status == 1 ? 'item-square' : 'item-has-square'}
          onClick={(e) => {
            this.recommedProduct(e, status);
          }}>
          {status == 1 ? '+推荐' : '已推荐'}
        </Flex>
      );
    }
    if (sign == 'ItemBar') {
      return (
        <Flex
          justify="center"
          className={status == 1 ? 'item-bar' : 'item-has-bar'}
          onClick={(e) => {
            this.recommedProduct(e, status);
          }}>
          {status == 1 ? '+推荐' : '已推荐'}
        </Flex>
      );
    }
  };

  /**
   * 渲染规格
   */
  renderSpecification = () => {
    const productInfo = this.props.data;
    console.log(productInfo, 'productInfoproductInfoproductInfo');
    const list = productInfo && productInfo.childList;
    return (
      <Flex direction="column" className="specification-area">
        <Flex justify="start" className="specification-title">
          规格
        </Flex>
        <Flex justify="start" className="specification-content">
          {list &&
            list.map((item, index) => {
              let imgUrl = item.mediaRespDtoList[0].path1;
              if (+imgUrl.charAt(imgUrl.length - 1) === 4) {
                imgUrl = item.mediaRespDtoList[1].path1;
              }
              return (
                <img
                  onClick={() => {
                    const { code, id, name, skuId } = item;
                    // let selectObject = {
                    //   itemSerial: id,
                    //   itemName: name,
                    //   skuSerial: skuId,
                    //   itemNum: 1,
                    // };
                    this.setState({
                      selectSpecificationIndex: index,
                      selectObject: item
                    });
                  }}
                  className={cx('specification-img', {
                    'specification-img-selected': this.state.selectSpecificationIndex === index
                  })}
                  src={imgUrl ? Util.getImgUrl(imgUrl, 100, 100) : ''}
                />
              );
            })}
        </Flex>
      </Flex>
    );
  };

  /**
   * 外部多规格弹窗
   */
  renderSkuMuityModal() {
    const { showSkuModal } = this.props.ShoppingCartMod;
    return (
      <SkuModal
        productMod={this.props.ShoppingCartMod}
        visible={showSkuModal}
        isSelectMall={this.props.isSelectMall}
        sourceTag={this.props.sourceTag || ''}
        onClose={() => {
          this.props.ShoppingCartMod.changeState({
            showSkuModal: false,
            checkItem: {}
          });
        }}
      />
    );
  }

  /**
   * 展示多规格弹框
   */
  renderMuitySpecificationModal = () => {
    const { showMuitySpecificationModal, selectObject, selectSpecificationIndex } = this.state;
    return (
      <Modal
        visible={showMuitySpecificationModal}
        transparent
        popup
        animationType="slide-up"
        maskClosable
        onClose={() => {
          this.setState({ showMuitySpecificationModal: false });
        }}>
        <div style={{ height: 200, overflow: 'scroll' }}>{this.renderSpecification()}</div>
        <CommonBtn
          title="确定"
          className="confirm-btn"
          onClick={async () => {
            let resultDomain = await this.props.AppMod.getCheckHostDomain();
            if (!resultDomain) return;
            if (selectSpecificationIndex === -1) {
              Toast.info('请先选择规格');
              return;
            }
            this.setState({ showMuitySpecificationModal: false });
            this.addTheCart(selectObject);
          }}
        />
      </Modal>
    );
  };

  // 渲染卖点
  renderSalePoint = () => {
    const { sellPointList } = this.props.data || {};
    if (!(sellPointList || []).length) return null;
    return (
      <div className="pointList">
        {(sellPointList || [])
          .filter((v, i) => i < 2)
          .map((item) => {
            return (
              <div
                className="pointItem"
                style={{
                  color: `#${item.sellPointColour}`,
                  border: `0.01rem solid #${item.sellPointColour}`,
                  borderRadius: '0.04rem'
                }}>
                {item.sellPointName}
              </div>
            );
          })}
      </div>
    );
  };

  /**
   * 橱窗（默认）
   */
  renderItemSquare() {
    const {
      name,
      code,
      mediaRespDtoList = [],
      sellPrice,
      maxPrice,
      price,
      picturePath,
      status,
      cornerMarkerRespDto,
      sellPointList,
      imgUrl: imageUrl,
      activityId: shareActivityId,
      id,
      type,
      isDisplay = 1, // 判断 是否是vip复购显示隐藏
      lastVisitDate,
      integration // 甄选积分
    } = this.props.data || {};
    const { flag = 1, smartCard } = this.props || {};
    const { showCart = 0 } = this.props || {};
    const imgUrl = imageUrl || Util.getProductImgUrl(mediaRespDtoList);
    // 是否失效
    const isInvalid = `${status}` == '0' || `${status}` == '2';
    const { recommend } = this.props.recommend || {};
    return (
      <div onClick={this.goDetail} className="product-list-item-square">
        <div className="img-box">
          {/* 显示最近浏览时间 */}
          {!!smartCard && !!lastVisitDate && (
            <div className="flex-center look-time">浏览时间：{lastVisitDate}</div>
          )}
          <img
            className="product-img"
            src={Util.getImgUrl(picturePath || imgUrl, 600)}
            alt="商品图片"
          />

          {/* 收藏组件 */}
          {!isInvalid && recommend != 'smartcard' && !smartCard && (
            <div
              className="collect-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                this.doCollect(showCart);
              }}>
              <CollectionBtn
                collect={this.isCollected}
                fill={this.isCollected ? '#F01B3F' : '#fff'}
                className="collect-icon"
              />
            </div>
          )}

          {/* 已失效遮罩 */}
          {!!isInvalid && (
            <Flex justify="center" align="center" className="invalid-box">
              <span>已失效</span>
            </Flex>
          )}

          {/* 角标组件 */}
          {cornerMarkerRespDto && (
            <CornerMarker
              visable={cornerMarkerRespDto.status == 1}
              className="corner-img"
              style={{
                color: cornerMarkerRespDto.weighColor,
                backgroundColor: cornerMarkerRespDto.backgroundColor
              }}
              data={cornerMarkerRespDto.name}
            />
          )}
        </div>

        <div
          className={cx('product-info clf', {
            'color-light-grey': isInvalid
          })}>
          <p className="ellipsis product-name">{name}</p>
          {/* 卖点 */}
          {this.renderSalePoint()}
          {!smartCard && <p className="product-code">{code}</p>}

          <Flex
            justify={recommend !== 'smartcard' ? 'between' : 'center'}
            align="center"
            className="price-box">
            {/* <p className = 'product-price'>{Util.formatMoney(sellPrice || price)}</p> */}
            {type != 6 && (
              <PriceText
                value={this.props.isSelectMall ? integration : sellPrice || price}
                showSymbol={false}
                showIcon
                iconValue={this.props.iconValue}
                hidePoint={this.props.isSelectMall}
                className="product-price"
              />
            )}
            {type == 6 && (
              <Flex
                style={{
                  justifyContent: 'flex-start',
                  height: '30px',
                  fontSize: '36px'
                }}>
                {this.props.isSelectMall ? (
                  <PriceText
                    value={integration}
                    showSymbol={false}
                    showIcon
                    className="price-text"
                    iconValue={this.props.iconValue}
                    hidePoint
                  />
                ) : (
                  Util.formatMoney(price)
                )}
                {price < maxPrice && (
                  <span
                    style={{
                      fontSize: '28px',
                      color: '#00000099',
                      marginLeft: '10px'
                    }}>
                    起
                  </span>
                )}
              </Flex>
            )}
            {recommend !== 'smartcard' && !smartCard ? (
              !isInvalid ? (
                <React.Fragment>
                  {+flag === 1 && (!!isDisplay || this.props.isSelectMall) && (
                    <div className="shopCart-round">
                      <span
                        className="iconfont icon-shopCat"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.addCart(type, showCart);
                        }}
                      />
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <span
                  className="iconfont icon-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.doCollect(showCart);
                  }}
                />
              )
            ) : null}
          </Flex>
          {recommend === 'smartcard' && this.renderRecommend('ItemSquare', id)}
        </div>
      </div>
    );
  }

  /**
   * 橱窗（UI改版） 对应页面: shop/productList 不影响公共样式最小化改动版本
   */
  renderItemSquareCustom() {
    const {
      name,
      code,
      mediaRespDtoList = [],
      sellPrice,
      maxPrice,
      price,
      picturePath,
      status,
      cornerMarkerRespDto,
      sellPointList,
      imgUrl: imageUrl,
      activityId: shareActivityId,
      id,
      type,
      isDisplay = 1, // 判断 是否是vip复购显示隐藏
      lastVisitDate,
      integration // 甄选积分
    } = this.props.data || {};
    const { flag = 1, smartCard } = this.props || {};
    const { showCart = 0 } = this.props || {};
    const imgUrl = imageUrl || Util.getProductImgUrl(mediaRespDtoList);
    // 是否失效
    const isInvalid = status == 0 || status == 2;
    const { recommend } = this.props.recommend || {};
    return (
      <div onClick={this.goDetail} className="product-list-item-square-custom">
        <div className="img-box">
          {/* 显示最近浏览时间 */}
          {!!smartCard && !!lastVisitDate && (
            <div className="flex-center look-time">浏览时间：{lastVisitDate}</div>
          )}
          <ImgWrap
            className="product-img"
            src={Util.getImgUrl(picturePath || imgUrl, 360)}
            w="3.6rem"
            h="3.6rem"
            r="0.08rem 0.08rem 0 0"
          />

          {/* 已失效遮罩 */}
          {!!isInvalid && (
            <Flex justify="center" align="center" className="invalid-box">
              <span>已失效</span>
            </Flex>
          )}

          {/* 角标组件 */}
          {cornerMarkerRespDto && (
            <CornerMarker
              visable={cornerMarkerRespDto.status == 1}
              className="corner-img"
              style={{
                color: cornerMarkerRespDto.weighColor,
                backgroundColor: cornerMarkerRespDto.backgroundColor
              }}
              data={cornerMarkerRespDto.name}
            />
          )}
        </div>

        <div
          className={cx('product-info clf', {
            'color-light-grey': isInvalid
          })}>
          <p className="ellipsis product-name">{name}</p>
          {/* 卖点 */}
          {this.renderSalePoint()}
          {!smartCard && <p className="product-code">{code}</p>}

          <Flex
            justify={recommend !== 'smartcard' ? 'between' : 'center'}
            align="end"
            className="price-box">
            {/* <p className = 'product-price'>{Util.formatMoney(sellPrice || price)}</p> */}
            {type != 6 && (
              <PriceText
                value={this.props.isSelectMall ? integration : sellPrice || price}
                showSymbol={false}
                showIcon
                iconValue={this.props.iconValue}
                hidePoint={this.props.isSelectMall}
                className="product-price"
              />
            )}
            {type == 6 && (
              <Flex
                justify="start"
                style={{
                  height: '30px',
                  fontSize: '36px'
                }}>
                {this.props.isSelectMall ? (
                  <PriceText
                    value={integration}
                    showSymbol={false}
                    showIcon
                    className="price-text"
                    iconValue={this.props.iconValue}
                    hidePoint
                  />
                ) : (
                  Util.formatMoney(price)
                )}
                {price < maxPrice && (
                  <span
                    style={{
                      fontSize: '28px',
                      color: '#00000099',
                      marginLeft: '10px'
                    }}>
                    起
                  </span>
                )}
              </Flex>
            )}
            {recommend !== 'smartcard' && !smartCard ? (
              !isInvalid ? (
                <React.Fragment>
                  {+flag === 1 && (!!isDisplay || this.props.isSelectMall) && (
                    <div className="shopCart-round">
                      <span
                        className="iconfont icon-shopCat"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.addCart(type, showCart);
                        }}
                      />
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <span
                  className="iconfont icon-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.doCollect(showCart);
                  }}
                />
              )
            ) : null}
          </Flex>
          {recommend === 'smartcard' && this.renderRecommend('ItemSquare', id)}
        </div>
      </div>
    );
  }

  /**
   * 长条
   */
  renderItemBar() {
    const {
      name,
      code,
      mediaRespDtoList = [],
      sellPrice,
      price,
      maxPrice,
      type,
      originPrice,
      status,
      cornerMarkerRespDto,
      sellPointList,
      imgUrl: imageUrl,
      id,
      isDisplay = 1, // 判断 是否是vip复购
      integration
    } = this.props.data || {};
    const { flag = 1 } = this.props || {};
    const { showCart = 0 } = this.props || {};
    const includesValue = imageUrl && imageUrl.includes('mp4');
    const imgUrl = includesValue
      ? Util.getProductImgUrl(mediaRespDtoList)
      : imageUrl || Util.getProductImgUrl(mediaRespDtoList);
    // 是否失效
    const isInvalid = `${status}` == '0' || `${status}` == '2';
    const { recommend } = this.props.recommend || {};
    return (
      <div onClick={this.goDetail} className="product-list-item-bar">
        <div className="img-box">
          <img className="product-img" src={Util.getImgUrl(imgUrl, 218)} alt="商品图片" />

          {/* 收藏组件 */}
          {!isInvalid && recommend != 'smartcard' && (
            <div
              className="collect-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                this.doCollect(showCart);
              }}>
              <CollectionBtn
                collect={this.isCollected}
                fill={this.isCollected ? '#F01B3F' : '#fff'}
                className="collect-icon"
              />
            </div>
          )}

          {/* 已失效遮罩 */}
          {!!isInvalid && (
            <Flex justify="center" align="center" className="invalid-box">
              <span>已失效</span>
            </Flex>
          )}

          {/* 角标组件 */}
          {cornerMarkerRespDto && (
            <CornerMarker
              visable={cornerMarkerRespDto.status == 1}
              className="corner-img"
              style={{
                color: cornerMarkerRespDto.weighColor,
                backgroundColor: cornerMarkerRespDto.backgroundColor
              }}
              data={cornerMarkerRespDto.name}
            />
          )}
        </div>

        <div
          className={cx('product-info clf', {
            'color-light-grey': isInvalid
          })}>
          <div className="product-top">
            <p className="ellipsis-one product-name">{name}</p>
            {/* 卖点 */}
            {this.renderSalePoint()}
            <p className="product-code">{code}</p>
          </div>

          <Flex justify="between" className="price-box">
            {type != 6 && (
              <PriceText
                value={this.props.isSelectMall ? integration : sellPrice || price}
                showSymbol={false}
                showIcon
                iconValue={this.props.iconValue}
                hidePoint={this.props.isSelectMall}
                className="price-text"
              />
            )}
            {type == 6 && (
              <Flex
                style={{
                  justifyContent: 'flex-start',
                  height: '30px',
                  fontSize: '36px'
                }}>
                {this.props.isSelectMall ? (
                  <PriceText
                    value={integration}
                    showSymbol={false}
                    showIcon
                    className="price-text"
                    iconValue={this.props.iconValue}
                    hidePoint
                  />
                ) : (
                  Util.formatMoney(price)
                )}
                {price < maxPrice && (
                  <span
                    style={{
                      fontSize: '28px',
                      color: '#00000099',
                      marginLeft: '10px'
                    }}>
                    起
                  </span>
                )}
              </Flex>
            )}
            <p className="product-price">
              {/* {Util.formatMoney(sellPrice || price)} */}
              {/* {originPrice && <span>{Util.formatMoney({value:originPrice,showPrefix:false})}</span>} */}
            </p>

            {recommend !== 'smartcard' ? (
              !isInvalid ? (
                (!!isDisplay || this.props.isSelectMall) && (
                  <React.Fragment>
                    {+flag === 1 && (
                      <div className="shopCart-round">
                        <span
                          className="iconfont icon-shopCat"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.addCart(type, showCart);
                          }}
                        />
                      </div>
                    )}
                  </React.Fragment>
                )
              ) : (
                <span
                  className="iconfont icon-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.doCollect(showCart);
                  }}
                />
              )
            ) : (
              this.renderRecommend('ItemBar', id)
            )}
          </Flex>
        </div>
      </div>
    );
  }

  /**
   * 长条(UI改版)
   */
  renderItemBarCustom() {
    const {
      name,
      code,
      mediaRespDtoList = [],
      sellPrice,
      price,
      maxPrice,
      type,
      originPrice,
      status,
      cornerMarkerRespDto,
      sellPointList,
      imgUrl: imageUrl,
      id,
      isDisplay = 1, // 判断 是否是vip复购
      integration
    } = this.props.data || {};
    const { flag = 1, smartCard } = this.props || {};
    const { showCart = 0 } = this.props || {};
    const includesValue = imageUrl && imageUrl.includes('mp4');
    const imgUrl = includesValue
      ? Util.getProductImgUrl(mediaRespDtoList)
      : imageUrl || Util.getProductImgUrl(mediaRespDtoList);
    // 是否失效
    const isInvalid = `${status}` == '0' || `${status}` == '2';
    const { recommend } = this.props.recommend || {};
    return (
      <div onClick={this.goDetail} className="product-list-item-bar-custom">
        <div className="img-box">
          <ImgWrap
            className="product-img"
            src={Util.getImgUrl(imgUrl, 240)}
            h="2.4rem"
            w="2.4rem"
            r="0.08rem"
          />

          {/* 已失效遮罩 */}
          {!!isInvalid && (
            <Flex justify="center" align="center" className="invalid-box">
              <span>已失效</span>
            </Flex>
          )}

          {/* 角标组件 */}
          {cornerMarkerRespDto && (
            <CornerMarker
              visable={cornerMarkerRespDto.status == 1}
              className="corner-img"
              style={{
                color: cornerMarkerRespDto.weighColor,
                backgroundColor: cornerMarkerRespDto.backgroundColor
              }}
              data={cornerMarkerRespDto.name}
            />
          )}
        </div>

        <div
          className={cx('product-info clf', {
            'color-light-grey': isInvalid
          })}>
          <div className="product-top">
            <p className="ellipsis-two product-name">{name}</p>
            {/* 卖点 */}
            {this.renderSalePoint()}
            <p className="product-code">{code}</p>
          </div>

          <Flex align="end" justify="between" className="price-box">
            {type != 6 && (
              <PriceText
                value={this.props.isSelectMall ? integration : sellPrice || price}
                showSymbol={false}
                showIcon
                iconValue={this.props.iconValue}
                hidePoint={this.props.isSelectMall}
                className="price-text"
              />
            )}
            {type == 6 && (
              <Flex
                style={{
                  justifyContent: 'flex-start',
                  height: '30px',
                  fontSize: '36px',
                  overflow: 'visible'
                }}>
                {this.props.isSelectMall ? (
                  <PriceText
                    value={integration}
                    showSymbol={false}
                    showIcon
                    className="price-text"
                    iconValue={this.props.iconValue}
                    hidePoint
                  />
                ) : (
                  Util.formatMoney(price)
                )}
                {price < maxPrice && (
                  <span
                    style={{
                      fontSize: '28px',
                      color: '#00000099',
                      marginLeft: '10px'
                    }}>
                    起
                  </span>
                )}
              </Flex>
            )}
            <p className="product-price">
              {/* {Util.formatMoney(sellPrice || price)} */}
              {/* {originPrice && <span>{Util.formatMoney({value:originPrice,showPrefix:false})}</span>} */}
            </p>

            {recommend !== 'smartcard' ? (
              !isInvalid ? (
                (!!isDisplay || this.props.isSelectMall) && (
                  <React.Fragment>
                    {+flag === 1 && (
                      <div className="shopCart-round">
                        <span
                          className="iconfont icon-shopCat"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.addCart(type, showCart);
                          }}
                        />
                      </div>
                    )}
                  </React.Fragment>
                )
              ) : (
                <span
                  className="iconfont icon-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.doCollect(showCart);
                  }}
                />
              )
            ) : (
              this.renderRecommend('ItemBar', id)
            )}
          </Flex>
        </div>
      </div>
    );
  }

  render() {
    const { isList = false, isCustom = false } = this.props;
    console.log('isListisList', isList);
    return (
      <div
        className={cx('common-product-item', {
          custom: !!isCustom,
          isList: !!isList
        })}>
        {/* 原有公共样式不动 */}
        {isList && !isCustom && this.renderItemBar()}
        {/* UI改版增加修改公共样式 最小化改动处理 */}
        {isList && !!isCustom && this.renderItemBarCustom()}
        {/* 原有公共样式不动 */}
        {!isList && !isCustom && this.renderItemSquare()}
        {/* UI改版增加修改公共样式 最小化改动处理 */}
        {!isList && !!isCustom && this.renderItemSquareCustom()}
        {/* 多规格弹框 */}
        {this.renderSkuMuityModal()}
        {/* {this.renderMuitySpecificationModal()} */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/ProductItem/index.js